import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { PermissionService } from '@core/services/permission.service';
import { RoleService } from '@core/services/role.service';
import { MatDialog } from '@angular/material/dialog';
import { PermissionsFilterComponent } from './permissions-filter/permissions-filter.component';
import {
  IPermission,
  IPermissionAssignment,
  IPermissionGroupAssignmentRes,
} from '@core/interfaces/ipermission';
import { IRoles } from '@core/interfaces/iroles';
import { ToastService } from '@core/services/toast.service';
import { TranslocoService } from '@jsverse/transloco';
import { Observable, take } from 'rxjs';
@Component({
    selector: 'drdp-permissions',
    templateUrl: './permissions.component.html',
    styleUrls: ['./permissions.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PermissionsComponent implements OnInit {
  show = false;
  originalRolesList?: IRoles[];
  roles?: IRoles[];
  roleIds: number[] = [];
  permissionGroup$?: Observable<IPermissionGroupAssignmentRes[]>;
  roles$?: Observable<IRoles[]>;
  assignmentList?: IPermissionAssignment[];
  uncategorizedList?: IPermission[];
  constructor(
    private permissionService: PermissionService,
    private RoleService: RoleService,
    public dialog: MatDialog,
    private toast: ToastService,
    private translocoService: TranslocoService
  ) {}

  ngOnInit(): void {
    this.getPermissionGroup();
    this.getPermissionAssignment();
    this.getAllRoles();
    this.getUncategorized();
  }

  getPermissionGroup(): void {
    this.permissionGroup$ = this.permissionService.getSuperPermissionGroups();
  }

  getPermissionAssignment(): void {
    this.permissionService
      .getPermissionAssignments()
      .subscribe((res: IPermissionAssignment[]) => {
        this.assignmentList = res;
      });
  }

  getAllRoles(): void {
    this.RoleService.getAllByOrder().subscribe((res: IRoles[]) => {
      this.originalRolesList = res;
      this.roles = res;
    });
  }

  getUncategorized(): void {
    this.permissionService.getUncategorizedPermission().pipe(
      take(1)
    ).subscribe((res: IPermission[]) => {
      this.uncategorizedList = res;
    });
  }

  openFilterDialog(): void {
    const dialogRef = this.dialog.open(PermissionsFilterComponent, {
      data: { orignalRolesList: this.originalRolesList, roleId: this.roleIds },
      disableClose: true,
    });

    dialogRef.afterClosed().subscribe((ids) => {
      if (ids) {
        this.roleIds = ids;
        this.filterRoles(this.roleIds);
      }
    });
  }

  filterRoles(roleIds: number[]): void {
    this.RoleService.filterRoles(roleIds).subscribe((res: IRoles[]) => {
      this.roles = res;
    });
  }

  updatePermission(permissionAssignment: any): void {
    this.permissionService
      .updatePermissionAssignment(permissionAssignment, this.translocoService.translate('accounts.permissions.updatedToast'))
      .pipe(take(1))
      .subscribe((req) => {
        this.toast.info(this.translocoService.translate('accounts.permissions.logoutRequiredToast'));
        this.getPermissionAssignment();
      });
  }

  downloadRoleReport(): void {
    if (!this.roles?.length) {
      return this.toast.warn(this.translocoService.translate('accounts.permissions.noRolesSelectedToast'));
    }

    this.RoleService.downloadRolesReport(this.roles).subscribe((res: any) => {
      const a = document.createElement('a');
      a.href = URL.createObjectURL(res.body);
      a.setAttribute('download', 'Roles.xlsx');
      a.click();
    });
  }
}
